import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=14401a83&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=14401a83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14401a83",
  null
  
)

export default component.exports